import { Stripe, StripeElements } from '@stripe/stripe-js';

export enum OnFormIsValidType {
  SAVED_PAYMENT_METHOD = 'saved_payment_method',
  NEW_CARD = 'new_card',
  NEW_BANK = 'new_bank',
}

export enum PaymentMethodType {
  CARD = 'card',
  BANK_ACCOUNT = 'bank_account',
}

export interface Address {
  line1: string;
  line2: string;
  postalCode: string;
  city: string;
  state: string;
  country: string;
}

export interface Payment {
  error?: unknown;
  paymentInformation?: PaymentInformation;
}

export interface CardPaymentInformation {
  paymentMethodType: PaymentMethodType.CARD;
  paymentMethodId: string;
  address?: Address;
}

export interface BankPaymentInformation {
  paymentMethodType: PaymentMethodType.BANK_ACCOUNT;
  plaidPublicToken: string;
  plaidAccountId: string;
  address: Address;
}

export interface SavedPaymentInformation {
  paymentMethodType: PaymentMethodType;
  paymentMethodId: string;
}

export type PaymentInformation =
  | CardPaymentInformation
  | BankPaymentInformation
  | SavedPaymentInformation;

export interface CreateStipePaymentMethodParams {
  stripe: Stripe;
  stripeElements: StripeElements;
  cardName: string;
  address: Address;
}

interface AddressFormIsValid {
  address1: string;
  address2: string;
  zipCode: string;
  city: string;
  state: string;
  country: string;
}

export interface BankFormIsValid extends AddressFormIsValid {
  type: OnFormIsValidType.NEW_BANK;
  plaidAccountId: string;
  plaidToken: string;
}

export interface CardFormIsValid extends AddressFormIsValid {
  type: OnFormIsValidType.NEW_CARD;
  stripe: Stripe;
  stripeElements: StripeElements;
  cardName: string;
}

export interface SavedMethodFormIsValid {
  type: OnFormIsValidType.SAVED_PAYMENT_METHOD;
  paymentType: PaymentMethodType;
  paymentMethodId: string;
}

export type OnFormIsValidOptions = BankFormIsValid | CardFormIsValid | SavedMethodFormIsValid;

export type OnFormIsValid = (valid: boolean, options?: OnFormIsValidOptions) => void;
